var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEdit({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 13,
    viewBox: "0 0 13 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.05857 12.138L10.2539 5.94265L7.31124 2.99998L1.11591 9.19531C1.03057 9.28065 0.969906 9.38798 0.940573 9.50465L0.253906 13L3.74857 12.3133C3.86591 12.284 3.97324 12.2233 4.05857 12.138ZM12.2539 3.94265C12.7746 3.42198 12.7746 2.57798 12.2539 2.05732L11.1966 0.999982C10.6759 0.479315 9.83191 0.479315 9.31124 0.999982L8.25391 2.05732L11.1966 4.99998L12.2539 3.94265Z",
    fill: "#505562"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.c24888a22198b5d023443d3528bc1b47.svg";
export { ForwardRef as ReactComponent };